import { FetchPartnerOnboardingEntitiesRequest, FetchPartnerOnboardingEntitiesResponse } from 'vopay';
import { useRef, useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchOnboardingEntities() {
  const [fetchingOnboardingEntities, setFetchingOnboardingEntities] = useState(false);

  const [onboardingEntities, setOnboardingEntities] =
    useState<
      Pick<FetchPartnerOnboardingEntitiesResponse, 'Entities' | 'StageCounts' | 'TotalEntities' | 'PaginationMetaData'>
    >();

  // Direct Pattern calls aren't cancelled, so fast filter or page changes overlap. Only the latest call may
  // store its result or end the fetching state; a superseded one still resolves (or throws) to its caller.
  const latestRequestIDRef = useRef(0);

  async function fetchOnboardingEntities(params: FetchPartnerOnboardingEntitiesRequest) {
    latestRequestIDRef.current += 1;
    const requestID = latestRequestIDRef.current;

    try {
      setFetchingOnboardingEntities(true);
      const res = await api.fetchPartnerOnboardingEntities(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      if (requestID === latestRequestIDRef.current) setOnboardingEntities(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      if (requestID === latestRequestIDRef.current) setFetchingOnboardingEntities(false);
    }
  }

  return { fetchingOnboardingEntities, onboardingEntities, fetchOnboardingEntities };
}
